export default class groupNavigation {
  constructor(el) {
    this.el = el;
    this.init();
  }

  init() {
    // Get active group id
    this.gid = this._getCurrentGroupID();
    this.gnd = this._getCurrentGroupNode();

    this._collapseGroupNodes();
  }

  _getCurrentGroupID() {
    return $(this.el).data('current-group-id');
  }

  _getCurrentGroupNode() {
    const citiesParentNode = document.querySelector('#js--lg--cities');
    const citiesNode = document.querySelector(
      `#js--lg--cities__options--${this.gid}`
    );
    const themesParentNode = document.querySelector('#js--lg--themes');
    const themesNode = document.querySelector(
      `#js--lg--themes__options--${this.gid}`
    );

    return citiesNode !== null
      ? [citiesParentNode, citiesNode]
      : [themesParentNode, themesNode];
  }

  _collapseGroupNodes() {
    if (groupNavigation._isInNode(this.gnd[0], this.gnd[1])) {
      $(this.gnd[0]).collapse();
      $(this.gnd[1]).collapse();

      groupNavigation._highlightCurrentLink(this.gnd[1]);
      // groupNavigation._highlightCurrentGroup(this.gnd[0], this.gnd[1]);
    }
  }

  static _highlightCurrentLink(node) {
    const uno = window.location.search.substr(1).split('&');
    const cgid = uno[0].split('=')[1];
    const urlPath = groupNavigation._getURLPath();
    let link = $(node).find(`a[href='${urlPath}']`);
    if (link.length === 0) {
      link = $(node).find(`a[href='${urlPath}?f=${cgid}']`);
    }
    link.addClass('lgi--current');
  }

  static _highlightCurrentGroup(parentNode, node) {
    $(parentNode).scrollTop(
      $(node)
        .prev()
        .position().top - $(parentNode).position().top
    );
  }

  static _getURLPath() {
    return window.location.pathname;
  }

  static _isInNode(node, subnode) {
    return node === subnode ? false : node.contains(subnode);
  }
}



// WEBPACK FOOTER //
// ./src/main/javascripts/modules/group_navigation.js